import { TAccount } from './accounts.types';

type TAccountHasPendingManualRepayment =
    | { hasPendingManualRepayment: true; pendingManualRepaymentAmount: number }
    | { hasPendingManualRepayment: false; pendingManualRepaymentAmount: null };

export const getAccountHasPendingManualRepayment = (
    account: TAccount
): TAccountHasPendingManualRepayment => {
    if (account.has_pending_manual_repayment) {
        return {
            hasPendingManualRepayment: true,
            // has_pending_manual_repayment checks if there is a pending manual repayment, which always has an amount
            pendingManualRepaymentAmount:
                account.pending_manual_repayment_amount!
        };
    }

    return {
        hasPendingManualRepayment: false,
        pendingManualRepaymentAmount: null
    };
};
